<template>
  <!-- 댓글 리스트 시작 -->

  <div class="comment-list">
    <div
      class="comment-list__thum"
      style="background-image: url(https://upload.wikimedia.org/wikipedia/commons/0/09/Man_Silhouette.png);"
    ></div>
    <div class="comment-list__content">
      <div class="content__head">
        <strong class="comment-name">{{isFilter ? '>>' : ''}}{{comment.userName}}</strong>
        <span class="comment-data">{{comment.updatedAt | dateFmtDot8 }}</span>
      </div>
      <div class="content__body">
        <p v-html="textarea"></p>
      </div>
      <div class="content__foot">
        <button-like
          type="comment"
          :row="comment"
          @refresh="reload"
        ></button-like>

        <!-- btn-comment 클릭시 comment-reply 클래스에 is-selected 추가 -->
        <button
          class="btn-comment"
          type="button"
          @click="search"
          v-if="!isFilter"
        >
          <span class="btn-comment__icon">
            <i class="material-icons">comment</i>
          </span>
          <span class="btn-comment__label">답글</span>
          <span class="btn-comment__count">{{comment.comments}}</span>
        </button>

        <div class="overflow-menu">
          <overflow-menu>
            <overflow-menu-item>
              <a @click="remove">
                수정
              </a>
            </overflow-menu-item>
            <overflow-menu-item>
              <a @click="remove">
                삭제
              </a>
            </overflow-menu-item>
          </overflow-menu>
        </div>
      </div>
    </div>

    <!-- 답글영역 시작 -->
    <!-- .comment-reply에 is-selected 추가시 답글영역이 보임. -->
    <div
      class="comment-reply"
      :class="isSelected"
    >
      <!-- 답글 리스트 -->
      <div
        class="comment-reply__list"
        v-for="sub in subComment.rows"
        :key="sub.seq"
      >
        <div
          class="comment-list__thum"
          style="background-image: url(https://upload.wikimedia.org/wikipedia/commons/0/09/Man_Silhouette.png);"
        ></div>
        <div class="comment-list__content">
          <div class="content__head">
            <strong class="comment-name">{{sub.userName}}</strong>
            <span class="comment-data">{{sub.updatedAt | dateFmtDot8}}</span>
          </div>
          <div class="content__body">
            <p>{{sub.content}}</p>
          </div>
          <div class="content__foot">
            <button-like
              type="comment"
              :row="sub"
              @refresh="search"
            ></button-like>
            <overflow-menu>
              <overflow-menu-item>
                <a @click="remove">
                  수정
                </a>
              </overflow-menu-item>
              <overflow-menu-item>
                <a @click="remove">
                  삭제
                </a>
              </overflow-menu-item>
            </overflow-menu>
          </div>
        </div>
      </div><!-- comment-replay__list -->

      <!-- 답글 인풋 -->
      <div class="p--24px pt--0px">
        <comment-input :create="create"></comment-input>

      </div>

      <!-- 답글답기 -->
      <div class="comment-replay__close">
        <button
          type="button"
          @click="toggleOff"
        >답글접기 <i class="material-icons">expand_less</i></button>
      </div>
    </div><!-- comment-reply -->
  </div>
</template>

<script>
import toggle from '@/component/js/toggle'

export default {
  mixins: [toggle],
  props: {
    row: { type: Object, required: true },
    isFilter: { type: Boolean, default: false }
  },
  data () {
    return {
      comment: this.row,
      subComment: {
        count: 0,
        rows: []
      }
    }
  },
  created () {
    // if (this.comment.comments) {
    //   this.search()
    // }
  },
  computed: {
    textarea () {
      return this.comment.content.replace(/\n/g, '<br>')
    }
  },
  methods: {
    async search () {
      this.toggleOn()
      const res = await this.$http.get(`/api/boards/${this.comment.boardId}/seqs/${this.comment.boardSeq}/comments`, { params: { parentSeq: this.comment.seq } })
      console.log(res.data)
      const { count, rows } = res.data
      this.subComment = {
        count,
        rows
      }
    },
    async create (content) {
      const uri = `/api/boards/${this.comment.boardId}/seqs/${this.comment.boardSeq}/comments/${this.comment.seq}`
      await this.$http.post(uri, { content })

      this.search()
    },
    async reload () {
      const res = await this.$http.get(`/api/boards/${this.comment.boardId}/seqs/${this.comment.boardSeq}/comments/${this.comment.seq}`)
      this.comment = res.data
    },
    async remove () {

    }
  },
  components: {
    ButtonLike: () => import('@/component/ui2/button/ButtonLike'),
    OverflowMenu: () => import('@/component/ui2/menu/OverflowMenu'),
    OverflowMenuItem: () => import('@/component/ui2/menu/OverflowMenuItem'),
    CommentInput: () => import('@/component/ui2/comment/CommentInput')
  }
}
</script>
